import React, { Fragment, useEffect, useState } from 'react'

import Link from 'next/link'
import { useRouter } from 'next/router'

import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons'
import Text from '@nexys/components/Typography/Text'
import { Button, Dropdown, Menu, Space } from 'antd'

import { AdminUniversalRole } from 'helpers/Authorization'
import { clearAuthStorage, getAuthTokenPayload } from 'utils/authStorage'

import ModalEditProfile from './ModalEditProfile'
import ModalPassword from './ModalPassword'
import ModalProfile from './ModalProfile'

import classNames from '../Header.module.scss'

export default function ProfileButton() {
  const [profile, setProfile] = useState(null)
  const [modalProfile, setModalProfile] = useState(false)
  const [modalPassword, setModalPassword] = useState(false)
  const [modalEditProfile, setModalEditProfile] = useState(false)
  const router = useRouter()
  const [user, setUser] = useState({
    token: '',
    fullName: '',
    userId: '',
    profile: '',
  })

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const token = localStorage?.getItem('access_token')
      const tokenData = getAuthTokenPayload()
      if (token && tokenData) {
        setUser({
          ...user,
          token,
          fullName: localStorage?.getItem('full_name'),
          userId: tokenData?.data?.id,
        })
      }
    }
  }, [])

  const handleLogout = (route?) => {
    clearAuthStorage()
    if (route) {
      router.push(route)
    } else {
      router.push('/')
    }
  }

  const getMenu = () => {
    const menu = [
      {
        label: (
          <div
            className={classNames.menu}
            onClick={() => setModalProfile(!modalProfile)}
          >
            <UserOutlined className={classNames.icon} />
            <span>Profile</span>
          </div>
        ),
      },
    ]

    if (AdminUniversalRole() && !router.pathname.includes('/admin')) {
      menu.push({
        label: (
          <div
            className={classNames.menuSmall}
            onClick={() => router.replace('/admin')}
          >
            <SettingOutlined className={classNames.icon} />
            <span>CMS</span>
          </div>
        ),
      })
    }

    menu.push({
      label: (
        <div
          className={classNames.menuSmall}
          style={{
            border: 0,
          }}
          onClick={() => handleLogout()}
        >
          <LogoutOutlined
            className={classNames.icon}
            style={{ fontSize: 15, marginLeft: 2 }}
          />
          <span>Logout</span>
        </div>
      ),
    })

    return (
      <Menu
        className={classNames.menuContainer}
        items={menu.map((x, i) => ({
          ...x,
          key: i,
        }))}
      />
    )
  }

  return (
    <Fragment>
      {user?.token ? (
        <Button
          className={classNames.MenuBtn}
          style={{
            width: '100%',
            height: '56px',
            borderRadius: '12px',
          }}
        >
          <Dropdown overlay={getMenu()} trigger={['click']}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <Text
                  strong={true}
                  fontFamily="regular"
                  color={`white`}
                  size={16}
                >
                  {` Hi, ${user?.fullName}`}
                </Text>
              </Space>
            </a>
          </Dropdown>
        </Button>
      ) : (
        <Link href={'/login'}>
          <a>
            <Button
              type="primary"
              style={{
                width: '178px',
                height: '56px',
                borderRadius: '12px',
              }}
            >
              <Text
                fontFamily={'regular'}
                color={`#FFFFFF`}
                style={{
                  fontSize: '16px',
                }}
              >
                Wilayah Penghuni
              </Text>
            </Button>
          </a>
        </Link>
      )}

      <ModalProfile
        active={modalProfile}
        setActive={setModalProfile}
        setActiveEditProfile={setModalEditProfile}
        setActivePassword={setModalPassword}
        userId={user?.userId}
        setProfile={setProfile}
      />
      <ModalPassword
        active={modalPassword}
        setActive={setModalPassword}
        setActiveProfile={setModalProfile}
        userId={user?.userId}
        logout={handleLogout}
      />
      <ModalEditProfile
        active={modalEditProfile}
        setActive={setModalEditProfile}
        setActiveProfile={setModalProfile}
        userId={user?.userId}
        profile={profile}
        setUser={setUser}
        user={user}
      />
    </Fragment>
  )
}
